import React from "react";
import "./FleetCoreManagementControlCentre.css";

import fleetcoreManagementControlCentreDashboardDesktop from "../../images/fleetcore-management-control-centre-dashboard-desktop.svg";
import fleetcoreManagementControlCentreDashboardMobile from "../../images/fleetcore-management-control-centre-dashboard-mobile.svg";

export default function FleetCoreManagementControlCentre() {
  return (
    <section className="fleetcore-management-control-centre" id="fleetcore-management" aria-labelledby="fleetcore-management-control-centre-title">
      <div className="fleetcore-management-control-centre__inner">
        <div className="fleetcore-management-control-centre__copy">
          <p className="fleetcore-management-control-centre__eyebrow">OPERATIONAL CONTROL</p>
          <h2 id="fleetcore-management-control-centre-title">See the fleet. Follow the evidence. Act with context.</h2>
          <p className="fleetcore-management-control-centre__body">Vehicles, drivers, shifts, fuel and condition exceptions come together in one management view—without losing the evidence behind the signal.</p>
        </div>
        <picture className="fleetcore-management-control-centre__dashboard">
          <source media="(max-width: 699px)" srcSet={fleetcoreManagementControlCentreDashboardMobile} />
          <img src={fleetcoreManagementControlCentreDashboardDesktop} alt="FleetCore management control centre showing fleet activity, evidence completeness and open reviews" />
        </picture>
        <div className="fleetcore-management-control-centre__principle">
          <strong>From fleet-wide signal to original evidence in one path.</strong>
          <span>Management sees the status and the evidence behind it.</span>
        </div>
      </div>
    </section>
  );
}